/* ── Layer data for German Shepherd anatomy atlas ── */

export const GROUP_COLORS = {
  spine: { fill: "#D4AF37", label: "Kręgosłup i głowa" },
  chest: { fill: "#D4AF37", label: "Klatka piersiowa" },
  front: { fill: "#5BA88C", label: "Kończyna przednia" },
  hind:  { fill: "#C87F4A", label: "Kończyna tylna" },
  body:  { fill: "#D4AF37", label: "Budowa zewnętrzna" },
};

export const externalLayer = {
  id: "external",
  name: "Budowa zewnętrzna",
  slug: "budowa-zewnetrzna",
  image: "/german_shepherd_anatomy.png",
  intro: "Budowa zewnętrzna owczarka niemieckiego to fundament oceny na wystawie i klucz do zrozumienia funkcjonalności psa. Każdy element sylwetki ma konkretne znaczenie - wpływa na ruch, wydolność i zdrowie.",
  keyFunctions: [
    "Klinowata głowa zapewnia siłę chwytu i precyzję zmysłów",
    "Linia górna (kłąb-grzbiet-zad) odpowiada za przenoszenie napędu",
    "Kątowanie kończyn determinuje zasięg i efektywność ruchu",
    "Proporcje ciała (110-117%) dają owczarkowi charakterystyczną sylwetkę"
  ],
  problems: [
    { name: "Dysplazja stawu biodrowego (HD)", desc: "Wada rozwojowa stawu biodrowego. Głowa kości udowej nie pasuje do panewki. Badanie RTG obowiązkowe w hodowli." },
    { name: "Dysplazja stawu łokciowego (ED)", desc: "Zaburzenie rozwoju stawu łokciowego. Może powodować kulawizny i ból. Kontrola RTG zalecana." },
    { name: "Problemy z uszami", desc: "Uszy powinny stać do 6-8 miesiąca. Wiszące lub miękkie uszy to wada dyskwalifikująca na wystawie." },
    { name: "Wady zgryzu", desc: "Prawidłowy zgryz nożycowy z 42 zębami. Brak zębów lub nieprawidłowy zgryz to poważna wada hodowlana." }
  ],
  funFacts: [
    "Uszy psa poruszają się dzięki wielu drobnym mięśniom, dlatego pies potrafi bardzo precyzyjnie wychwytywać dźwięki.",
    "Ogon pomaga psu nie tylko w komunikacji, ale też w utrzymaniu równowagi podczas ruchu.",
    "Sylwetka psa wpływa nie tylko na wygląd, ale także na wygodę poruszania się i wydolność."
  ],
  points: [
    {
      id: "glowa", name: "Głowa", group: "body",
      position: { x: 20, y: 26 },
      area: "13,16 18,12 24,13 27,18 26,24 24,32 19,34 14,30 12,25",
      description: "Klinowata, proporcjonalna do ciała, sucha i umiarkowanie szeroka. Czoło lekko sklepione, stop wyraźny ale nie ostry. Kufa mocna, prosta.",
      function: "Centrum zmysłów: wzrok, słuch, węch. Klinowaty kształt zapewnia optymalną siłę szczęk.",
      movement: "Głowa balansuje ciało w ruchu. Przy kłusie obniżana do poziomu grzbietu, stabilizuje linię górną.",
      breed: "Proporcja czaszka:kufa = 50:50. Oczy ciemne, migdałowate. Nos zawsze czarny. Zgryz nożycowy, 42 zęby."
    },
    {
      id: "uszy", name: "Uszy", group: "body",
      position: { x: 26, y: 11 },
      area: "22,3 25,1 29,5 28,12 26,15 22,12",
      description: "Stojące, średniej wielkości, szeroko osadzone u podstawy, noszone pionowo. Końce lekko zaostrzone, skierowane do przodu.",
      function: "Precyzyjna lokalizacja źródła dźwięku. Kluczowe dla psa roboczego i stróżującego.",
      movement: "Przy ruchu uszy wskazują skupienie i kierunek uwagi psa. Reagują na dźwięki otoczenia.",
      breed: "Muszą stać do 6-8 miesiąca. Uszy wiszące, załamane lub miękkie to poważna wada."
    },
    {
      id: "szyja", name: "Szyja", group: "body",
      position: { x: 27, y: 24 },
      area: "24,18 30,16 34,20 33,28 28,30 24,26",
      description: "Silna, muskularna, bez podgardla. Kąt ~45° z tułowiem. Stanowi ok. 35% wysokości w kłębie.",
      function: "Pomost między głową a tułowiem. Przenosi siły i zapewnia równowagę w ruchu.",
      movement: "Przy kłusie szyja obniżana. Przy ożywieniu unoszona wysoko. Amortyzuje ruchy głowy.",
      breed: "Podgardle (luźna skóra) jest wadą. Szyja zbyt krótka lub długa zaburza proporcje i ruch."
    },
    {
      id: "klab", name: "Kłąb", group: "body",
      position: { x: 33, y: 17 },
      area: "30,11 36,9 39,13 37,22 33,23 30,18",
      description: "Najwyższy punkt grzbietu. Długi, wyraźny, wysoki i dobrze umięśniony. Punkt pomiaru wysokości psa.",
      function: "Miejsce przyczepu mięśni łopatki. Wysoki kłąb = lepszy kąt łopatki = dłuższy krok przedni.",
      movement: "Dominuje nad linią grzbietu. Zapewnia płynne przenoszenie siły z kończyn na tułów.",
      breed: "Wysokość w kłębie: psy 60-65cm, suki 55-60cm. Nisko osadzony kłąb to poważna wada."
    },
    {
      id: "grzbiet", name: "Grzbiet", group: "body",
      position: { x: 43, y: 30 },
      area: "37,18 50,22 50,36 38,34 36,26",
      description: "Prosty, silny, dobrze umięśniony. Linia biegnie bez przerwy od kłębu do lekko opadającego zadu.",
      function: "Przenosi napęd z kończyn tylnych na przednie. Utrzymuje stabilność ciała w ruchu.",
      movement: "Elastyczność grzbietu pozwala na wydajny kłus dalekiego zasięgu. Nie może kołysać się w ruchu.",
      breed: "Proporcja tułów:wysokość = 110-117%. Karpiowaty lub wklęsły grzbiet to wady."
    },
    {
      id: "ledz", name: "Lędźwie", group: "body",
      position: { x: 52, y: 34 },
      area: "49,24 57,28 56,40 49,38",
      description: "Szerokie, silne, dobrze umięśnione. Łączą grzbiet z zadem. Powinny być krótkie i mocne.",
      function: "Most napędowy — przenoszą siłę z kończyn tylnych przez miednicę na grzbiet.",
      movement: "Zbyt długie lędźwie = kołysanie zadu. Krótkie i mocne = sprężysty, stabilny kłus.",
      breed: "Krótkie, mocne lędźwie to cecha pożądana. Słabe lędźwie objawiają się miękką linią górną."
    },
    {
      id: "zad", name: "Zad", group: "body",
      position: { x: 62, y: 39 },
      area: "56,30 66,32 68,44 66,48 58,46 55,38",
      description: "Długi, lekko opadający (~23°), przechodzący płynnie w nasadę ogona. Dobrze umięśniony i szeroki.",
      function: "Punkt przyczepu najsilniejszych mięśni tylnych kończyn. Efektywne przenoszenie napędu.",
      movement: "Kąt zadu determinuje zakres ruchu kończyn tylnych. Zbyt stromy = krótki krok.",
      breed: "Optymalnie: 23° do poziomu. Zad stromy lub płaski to wada wpływająca na ruch i sylwetkę."
    },
    {
      id: "ogon", name: "Ogon", group: "body",
      position: { x: 76, y: 65 },
      area: "66,48 72,42 80,56 84,66 80,72 74,68 68,54",
      description: "Sięga co najmniej do stawu skokowego. Pokryty gęstą sierścią. W spoczynku noszony w łagodnym łuku.",
      function: "Ster i przeciwwaga w ruchu. Stabilizuje ciało podczas biegu, zwrotów i skoków.",
      movement: "Przy kłusie lekko unoszony. Nie powinien być noszony powyżej linii grzbietu.",
      breed: "Skręcony, zbyt krótki lub zawinięty na bok to wady. Harmonijnie przedłuża linię grzbietu."
    },
    {
      id: "klatka", name: "Klatka piersiowa", group: "body",
      position: { x: 32, y: 48 },
      area: "25,34 36,32 38,40 37,56 28,58 24,50 24,42",
      description: "Umiarkowanie szeroka, z długim mostkiem. Żebra umiarkowanie sklepione. Głębokość ~45-48% wysokości.",
      function: "Chroni serce i płuca. Pojemność wpływa na wydolność psa podczas wysiłku.",
      movement: "Zbyt beczkowata utrudnia swobodny ruch kończyn przednich. Zbyt płaska zmniejsza wydolność.",
      breed: "Głębokość do łokcia. Prawidłowa klatka wpływa na postawę kończyn przednich i harmonię sylwetki."
    },
    {
      id: "przednie", name: "Kończyny przednie", group: "body",
      position: { x: 30, y: 65 },
      area: "23,56 35,54 36,66 35,80 30,84 25,84 23,78 22,64",
      description: "Łopatki długie, skośne (45°). Ramię z łopatką ~90°. Przedramiona proste. Śródręcze lekko skośne.",
      function: "Amortyzują uderzenia w ruchu. Odpowiadają za kierunek biegu.",
      movement: "Prawidłowe kątowanie = długi krok przedni. Zbyt strome ustawienie skraca krok.",
      breed: "Kąt łopatki 45°, kąt łopatka-ramię ~90°. Łokcie nie odstawione. Równoległe z przodu."
    },
    {
      id: "tylne", name: "Kończyny tylne", group: "body",
      position: { x: 64, y: 58 },
      area: "57,48 68,46 72,54 71,66 68,74 62,74 58,64 56,54",
      description: "Udo szerokie, umięśnione. Staw kolanowy dobrze kątowany. Staw skokowy mocny i sprężysty.",
      function: "Główny napęd psa. Generują siłę przenoszoną przez lędźwie na resztę ciała.",
      movement: "Prawidłowe kątowanie = wydajny kłus bez nadmiernego wysiłku. Dalekosięgny wykrok.",
      breed: "Przekątowanie obciąża stawy. Zbyt strome ogranicza zasięg. Wilcze pazury niedopuszczalne."
    },
    {
      id: "lapy", name: "Łapy", group: "body",
      position: { x: 30, y: 86 },
      area: "24,82 34,80 36,90 33,96 26,96 22,90",
      description: "Okrągłe, zwarte, dobrze wysklepione (łapa kocia). Opuszki twarde, ciemne. Pazury krótkie.",
      function: "Punkt kontaktu z podłożem. Absorbują wstrząsy, zapewniają przyczepność.",
      movement: "Zwarte łapy = lepsza efektywność ruchu. Rozpłaszczone łapy tracą energię przy każdym kroku.",
      breed: "Łapa płaska lub zajęcza to poważna wada. Opuszki muszą być twarde, odporne na ścieranie."
    },
    {
      id: "siersc", name: "Szata", group: "body",
      position: { x: 42, y: 42 },
      area: "37,34 48,36 48,48 42,52 36,50 34,42",
      description: "Podwójna: gęsty podszerstek + twardy włos okrywowy. Na szyi i udach dłuższa.",
      function: "Izolacja termiczna (podszerstek) + ochrona przed wodą i urazami (włos okrywowy).",
      movement: "Prawidłowa szata podkreśla muskulaturę i budowę ciała widoczną w ruchu.",
      breed: "Umaszczenia: czarne z podpaleniem, jednolicie czarne, szaro-podpalane. Brak podszerstka = wada."
    }
  ]
};

export const skeletalLayer = {
  id: "skeletal",
  name: "Układ kostny",
  slug: "uklad-kostny",
  image: "/anatomy_skeletal.png",
  intro: "Układ kostny owczarka to konstrukcja nośna, która determinuje sylwetkę, ruch i zdrowie psa. Od kształtu czaszki po ostatni kręg ogona - każda kość ma swoje zadanie.",
  keyFunctions: [
    "Kręgosłup przenosi siłę napędu z tyłu na przód ciała",
    "Klatka piersiowa chroni serce i płuca, wpływając na wydolność",
    "Kątowanie kości kończyn decyduje o zasięgu i efektywności ruchu",
    "Miednica i kość krzyżowa to centrum mocy napędowej psa"
  ],
  problems: [
    { name: "Dysplazja stawu biodrowego (HD)", desc: "Najczęstsza choroba stawów u owczarków. Głowa kości udowej nie pasuje do panewki. RTG HD obowiązkowe w hodowli." },
    { name: "Spondyloza", desc: "Zwyrodnienie kręgosłupa - tworzenie się mostków kostnych między kręgami. Częste u starszych psów. Może ograniczać ruchomość." },
    { name: "Zwichnięcie rzepki", desc: "Rzepka wysuwa się z rowka kości udowej. Powoduje chwilową kulawizną. W cięższych przypadkach wymaga operacji." },
    { name: "Osteochondroza (OCD)", desc: "Zaburzenie rozwoju chrząstki stawowej. Dotyka młodych, szybko rosnących psów. Najczęściej w stawie barkowym." }
  ],
  funFacts: [
    "Pies ma zwykle więcej kości niż człowiek.",
    "Ogon psa jest przedłużeniem kręgosłupa i składa się z wielu kręgów.",
    "Klatka piersiowa chroni serce i płuca, ale też ma duże znaczenie dla wydolności organizmu."
  ],
  points: [
    /* ═══════ KRĘGOSŁUP I GŁOWA (gold) ═══════ */
    {
      id: "czaszka", name: "Czaszka", group: "spine",
      position: { x: 18, y: 22 },
      area: "11,14 19,10 25,14 25,28 20,32 13,30 10,24",
      description: "Składa się z czaszki mózgowej i twarzowej. Kształt klinowaty, 42 zęby ułożone w zgryz nożycowy. To fundament całej głowy psa.",
      function: "Chroni mózg i narządy zmysłów. Osadza zęby i potężne mięśnie żucia, które dają owczarkowi siłę chwytu.",
      movement: "Masa i proporcje czaszki wpływają na balans całego ciała w ruchu. Zbyt ciężka głowa obciąża przód psa.",
      breed: "Proporcja czaszka do kufy 50:50. Stop wyraźny, linie równoległe. Brak choćby jednego zęba to wada."
    },
    {
      id: "kregoslup_szyjny", name: "Odcinek szyjny", group: "spine",
      position: { x: 28, y: 18 },
      area: "24,12 33,10 35,18 33,24 26,22 23,16",
      description: "7 kręgów szyjnych — tyle samo co u żyrafy i u człowieka. Łączy czaszkę z kręgosłupem piersiowym i daje szyi pełną ruchomość.",
      function: "Zapewnia pełen zakres ruchu głowy — góra, dół, boki. Chroni rdzeń kręgowy w odcinku szyjnym.",
      movement: "Szyja to przeciwwaga — przy kłusie pies obniża głowę, by ustabilizować linię górną i oszczędzać energię.",
      breed: "Szyja powinna stanowić ~35% wysokości w kłębie. Zbyt krótka lub zbyt długa zaburza całą sylwetkę."
    },
    {
      id: "kregoslup_piersiowy", name: "Odcinek piersiowy", group: "spine",
      position: { x: 40, y: 16 },
      area: "34,10 48,12 50,20 48,26 35,24 33,16",
      description: "13 kręgów piersiowych — najdłuższy odcinek kręgosłupa. Do każdego kręgu przyczepia się para żeber. To szkielet tułowia.",
      function: "Tworzy sztywną konstrukcję ochronną dla serca i płuc. Jednocześnie musi zachować elastyczność do ruchu.",
      movement: "Ten odcinek odpowiada za sprężynowanie grzbietu w kłusie. Zbyt sztywny grzbiet = krótki, nieefektywny krok.",
      breed: "Kręgosłup piersiowy tworzy linię górną — kluczowy element oceny na wystawie. Musi być prosty, bez załamań."
    },
    {
      id: "kregoslup_ledzwiowy", name: "Odcinek lędźwiowy", group: "spine",
      position: { x: 54, y: 22 },
      area: "49,16 59,18 60,26 58,32 50,30 48,22",
      description: "7 kręgów lędźwiowych - most napędowy między klatką piersiową a miednicą. Kręgi krótkie i masywne.",
      function: "Przenosi siłę napędową z tylnych kończyn na resztę ciała. To tutaj generuje się moc ruchu.",
      movement: "Krótkie, mocne lędźwie = stabilny, sprężysty kłus. Zbyt długie = kołysanie zadu i utrata energii.",
      breed: "Mocne lędźwie to cecha pożądana u psa roboczego. Słabe lędźwie widać od razu — miękka linia górna w ruchu."
    },
    {
      id: "kosc_krzyzowa", name: "Kość krzyżowa", group: "spine",
      position: { x: 62, y: 30 },
      area: "58,24 66,26 68,34 66,38 60,38 56,32",
      description: "3 zrośnięte kręgi tworzące jedną masywną kość. Łączy kręgosłup z miednicą — kluczowe połączenie w ciele psa.",
      function: "Punkt podparcia dla miednicy i kończyn tylnych. Cała siła napędu przechodzi przez to połączenie.",
      movement: "Kąt kości krzyżowej determinuje ustawienie zadu i zasięg wykroku tylnych kończyn.",
      breed: "Optymalny kąt ~23° do poziomu. Zbyt stromy kąt ogranicza ruch. Zbyt płaski zaburza sylwetkę."
    },
    {
      id: "kregi_ogonowe", name: "Kręgi ogonowe", group: "spine",
      position: { x: 74, y: 48 },
      area: "67,38 76,42 80,52 78,60 74,58 66,46",
      description: "20–23 kręgów ogonowych — naturalne przedłużenie kręgosłupa. Stopniowo maleją ku końcowi ogona.",
      function: "Ogon to ster i przeciwwaga w ruchu. Stabilizuje ciało w zakrętach i skokach. Wyraża też emocje psa.",
      movement: "Przy kłusie ogon lekko uniesiony. Nie powinien przekraczać linii grzbietu. Pomaga w utrzymaniu równowagi.",
      breed: "Ogon musi sięgać co najmniej do stawu skokowego. Skręcony, zawinięty lub zbyt krótki — to wady."
    },

    /* ═══════ KLATKA PIERSIOWA (gold) ═══════ */
    {
      id: "zebra", name: "Żebra", group: "chest",
      position: { x: 38, y: 38 },
      area: "32,26 46,24 48,38 46,50 34,50 30,38",
      description: "13 par żeber tworzy klatkę piersiową. 9 par prawdziwych (połączonych z mostkiem) i 4 pary wolne. Chronią najważniejsze narządy.",
      function: "Tworzą przestrzeń dla serca i płuc. Ruchome żebra pozwalają na rozszerzanie klatki przy oddychaniu.",
      movement: "Kształt żeber decyduje o pojemności płuc — a to bezpośrednio wpływa na wytrzymałość psa w długim kłusie.",
      breed: "Żebra umiarkowanie sklepione. Zbyt beczkowate utrudniają ruch przodu. Zbyt płaskie zmniejszają wydolność."
    },
    {
      id: "mostek", name: "Mostek", group: "chest",
      position: { x: 34, y: 54 },
      area: "30,50 40,48 42,56 40,62 32,62 28,56",
      description: "Płaska kość biegnąca wzdłuż spodu klatki piersiowej. Łączy żebra od dołu i zamyka klatkę. Jej długość wpływa na głębokość klatki.",
      function: "Stabilizuje klatkę piersiową od spodu. Długi mostek = głęboka klatka = lepsza wydolność.",
      movement: "Głębokość klatki (do łokcia) zależy od długości mostka. To wpływa na ustawienie kończyn przednich.",
      breed: "Sędzia ocenia głębokość klatki piersiowej — powinna sięgać do poziomu łokci. Mostek powinien być dobrze rozwinięty."
    },

    /* ═══════ KOŃCZYNA PRZEDNIA (green) ═══════ */
    {
      id: "lopatka", name: "Łopatka", group: "front",
      position: { x: 30, y: 26 },
      area: "26,18 35,16 37,24 35,34 28,34 24,26",
      description: "Płaska kość trójkątna. Wyjątkowa cecha — jest połączona z ciałem TYLKO mięśniami, nie stawem kostnym. Dlatego pływa po klatce.",
      function: "Przenosi całe obciążenie kończyn przednich na tułów. Kąt łopatki decyduje o zasięgu kroku przedniego.",
      movement: "Łopatka pod kątem 45° do poziomu = optymalny, najdłuższy możliwy krok przedni. Zbyt stroma = krok krótki.",
      breed: "Kąt łopatki to jeden z najważniejszych elementów oceny. Decyduje o wyglądzie przodu psa i jakości ruchu."
    },
    {
      id: "kosc_ramienna", name: "Kość ramienna", group: "front",
      position: { x: 28, y: 40 },
      area: "24,34 33,32 35,42 33,50 26,50 22,42",
      description: "Łączy łopatkę ze stawem łokciowym. Tworzy z łopatką kluczowy kąt około 90° — to determinuje ruch przodu psa.",
      function: "Działa jak dźwignia — jej długość i kąt wpływają na długość kroku. Zbyt krótka = ograniczony ruch.",
      movement: "Kąt łopatka–ramię ~90° = najdłuższy możliwy krok przedni. Mniejszy kąt = kończyna zbyt stroma.",
      breed: "Prawidłowy kąt łopatka–ramię jest trudny do uzyskania w hodowli. Dlatego tak ceniony na wystawach."
    },
    {
      id: "przedramie", name: "Przedramię", group: "front",
      position: { x: 26, y: 56 },
      area: "22,50 31,48 33,58 31,68 24,68 20,58",
      description: "Kość promieniowa i łokciowa — dwie kości biegnące równolegle. Proste, mocne, widziane z przodu idealnie równoległe.",
      function: "Amortyzują uderzenia przy lądowaniu. Przenoszą obciążenie z ramienia na łapę. Muszą być proste.",
      movement: "Krzywe przedramiona = nierówny rozkład sił i szybsze zużycie stawów. Prostota to klucz do zdrowia.",
      breed: "Widziane z przodu — idealnie proste i równoległe. Łokcie ściśle przylegające, nie odstawione."
    },
    {
      id: "nadgarstek_srodrecze", name: "Nadgarstek i śródręcze", group: "front",
      position: { x: 26, y: 76 },
      area: "22,70 31,68 33,78 31,86 24,86 20,78",
      description: "Nadgarstek to złożony staw złożony z drobnych kostek. Śródręcze — 5 kości łączących nadgarstek z palcami. Lekko skośne (~20°).",
      function: "Nadgarstek amortyzuje uderzenia. Skośne śródręcze działa jak sprężyna — pochłania wstrząsy przy każdym kroku.",
      movement: "Prawidłowy kąt śródręcza (~20-22°) = dobra amortyzacja. Zbyt strome = twarde lądowanie obciążające stawy.",
      breed: "Śródręcze zbyt miękkie (przegięte) lub zbyt strome to wady. Powinno być sprężyste i mocne."
    },

    /* ═══════ KOŃCZYNA TYLNA (orange) ═══════ */
    {
      id: "miednica", name: "Miednica", group: "hind",
      position: { x: 60, y: 34 },
      area: "55,26 66,28 68,36 66,42 58,42 54,34",
      description: "Masywna kość złożona z trzech części: biodrowej, kulszowej i łonowej. Tworzy staw biodrowy — centrum mocy psa.",
      function: "Punkt przyczepu najmocniejszych mięśni napędowych. Łączy kręgosłup z kończynami tylnymi.",
      movement: "Kąt nachylenia miednicy = kąt zadu. To determinuje, jak daleko pies może wykroczyć tylną nogą.",
      breed: "Prawidłowy kąt (~23°) = efektywny napęd. Dysplazja stawu biodrowego to częsty problem — RTG obowiązkowe."
    },
    {
      id: "kosc_udowa", name: "Kość udowa", group: "hind",
      position: { x: 62, y: 48 },
      area: "57,42 67,40 69,50 67,58 59,58 55,50",
      description: "Najdłuższa i najmocniejsza kość w ciele psa. Łączy staw biodrowy ze stawem kolanowym. To główna dźwignia napędu.",
      function: "Mięśnie uda generują siłę, która napędza całego psa. Długość kości udowej wpływa na zasięg kroku.",
      movement: "Długa kość udowa = daleki wykrok. Krótka = ograniczony ruch. To bezpośrednio widać w kłusie.",
      breed: "Dysplazja stawu biodrowego dotyczy tego połączenia — głowa kości musi idealnie pasować do panewki miednicy."
    },
    {
      id: "staw_kolanowy", name: "Staw kolanowy i podudzie", group: "hind",
      position: { x: 64, y: 60 },
      area: "59,56 69,54 72,62 70,70 63,70 58,64",
      description: "Staw kolanowy łączy kość udową z piszczelą. Podudzie (piszczel + strzałkowa) przenosi napęd w dół kończyny.",
      function: "Staw kolanowy musi być dobrze kątowany — to decyduje o sile i zasięgu ruchu tylnej kończyny.",
      movement: "Zbyt strome kolano = krótki krok. Zbyt głębokie kątowanie = nadmierne obciążenie więzadeł i stawów.",
      breed: "Sędzia ocenia kątowanie kolana z boku — powinno być wyraźne, ale nie przesadne. Rzepka musi być stabilna."
    },
    {
      id: "staw_skokowy", name: "Staw skokowy i śródstopie", group: "hind",
      position: { x: 68, y: 74 },
      area: "64,68 74,66 76,76 74,86 68,86 62,76",
      description: "Staw skokowy to odpowiednik ludzkiej kostki — sprężyna napędowa psa. Śródstopie i palce tworzą tylną łapę.",
      function: "Magazynuje i uwalnia energię przy każdym kroku. Mocny staw = wydajny, sprężysty ruch.",
      movement: "Słaby staw skokowy to jak pęknięta sprężyna — pies traci energię ruchu. Powinien być suchy i mocny.",
      breed: "Z tyłu kończyny muszą być proste i równoległe. Stawy zbieżne lub rozbieżne to poważna wada."
    }
  ]
};

export const LAYERS_META = [
  { id: "external", name: "Budowa zewnętrzna", slug: "budowa-zewnetrzna", ready: true },
  { id: "skeletal", name: "Układ kostny", slug: "uklad-kostny", ready: true },
  { id: "muscular", name: "Układ mięśniowy", slug: "uklad-miesniowy", ready: false },
  { id: "movement", name: "Ruch i biomechanika", slug: "ruch", ready: false },
];
